import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import Typography from 'src/common/components/Typography';
import { CarouselProvider } from 'src/common/providers/CarouselProvider';
import CarouselButtons from 'src/common/components/dockyard/CarouselButtons';
import Carousel from 'src/common/components/dockyard/Carousel';
import StaticReview, { StaticReviewProps } from '../StaticReview';
import styles from './StaticReviews.module.scss';

const staticReviews: StaticReviewProps[] = [
  {
    title: 'static-reviews--tag-1',
    rating: 5,
    review: 'static-reviews--content-1',
    user: {
      first_name: 'Linda',
      last_name: 'C',
      has_photo: false,
    },
    url: 'https://www.getmyboat.com/boat-rental/tours/Newport-Beach--CA--United-States/',
  },
  {
    title: 'static-reviews--tag-2',
    rating: 5,
    review: 'static-reviews--content-2',
    user: {
      first_name: 'Courtney',
      last_name: 'K',
      has_photo: false,
    },
    url: 'https://www.getmyboat.com/boat-rental/Austin--TX--United-States/',
  },
  {
    title: 'static-reviews--tag-3',
    rating: 5,
    review: 'static-reviews--content-3',
    user: {
      first_name: 'Serena',
      last_name: 'E',
      photo_url: 'https://img.getmyboat.com/images/6143301a95755/processed.png',
      has_photo: true,
    },
    url: 'https://www.getmyboat.com/boat-rental/fishing-charters/San-Diego--CA--United-States/',
  },
  {
    title: 'static-reviews--tag-4',
    rating: 5,
    review: 'static-reviews--content-4',
    user: {
      first_name: 'Christine',
      last_name: 'W',
      has_photo: false,
    },
    url: 'https://www.getmyboat.com/boat-rental/Miami--FL--United-States/',
  },
  {
    title: 'static-reviews--tag-5',
    rating: 5,
    review: 'static-reviews--content-5',
    user: {
      first_name: 'Alyza',
      last_name: 'L',
      photo_url: 'https://img.getmyboat.com/images/5f3a1efe79ccf/processed.png',
      has_photo: true,
    },
    url: 'https://www.getmyboat.com/boat-rental/Long-Beach--CA--United-States/',
  },
  {
    title: 'static-reviews--tag-6',
    rating: 5,
    review: 'static-reviews--content-6',
    user: {
      first_name: 'Kelsey',
      last_name: 'V',
      has_photo: false,
    },
    url: 'https://www.getmyboat.com/boat-rental/Chicago--IL--United-States/',
  },
];

type StaticReviewsProps = {
  variant?: 'homepage' | 'how-it-works';
};

const StaticReviews: FC<StaticReviewsProps> = ({ variant = 'homepage' }) => {
  const [t] = useTranslation('static-reviews');

  return (
    <PitchPageLayout
      backgroundImage={variant === 'homepage' ? 'home-page/palms.jpg' : undefined}
      backgroundColor={variant === 'how-it-works' ? 'midnight02' : undefined}
    >
      <div className={styles.root}>
        <div className={styles.title}>
          <Typography
            type="h3"
            size="display-5"
            sizeFromBreakpointM="display-4"
          >
            {t('static-reviews--title')}
          </Typography>
        </div>
        <CarouselProvider>
          <Carousel>
            {staticReviews.map((review) => (
              <StaticReview
                key={review.title}
                title={t(review.title)}
                rating={review.rating}
                review={t(review.review)}
                user={review.user}
                url={review.url}
              />
            ))}
          </Carousel>
          <CarouselButtons
            spacing="together"
            variant="primary-dark"
          />
        </CarouselProvider>
      </div>
    </PitchPageLayout>
  );
};

export default StaticReviews;
